
import { Component, Prop, Vue } from "vue-property-decorator";
import Restaurant from "@/domain/restaurant/Restaurant";
import RestaurantPropertiesForm from "@/components/restaurant/RestaurantPropertiesForm.vue";
import WorkingHoursCard from "@/components/restaurant/workingHours/WorkingHoursCard.vue";
import WorkingHoursList from "@/components/restaurant/workingHours/WorkingHoursList.vue";
import ConfirmationDialog from "@/components/alert/ConfirmationDialog.vue";
import RemoteServices from "@/services/RemoteServices";
import DialogBanner from "@/components/app/DialogBanner.vue";
import ClosedPeriodList from "@/components/restaurant/holiday/ClosedPeriodList.vue";
import SpecialOpenDaysList from "@/components/restaurant/specialOpenDays/SpecialOpenDateList.vue";
@Component({
  components: {
    SpecialOpenDaysList,
    ClosedPeriodList,
    ConfirmationDialog,
    WorkingHoursList,
    WorkingHoursCard,
    RestaurantPropertiesForm,
    DialogBanner
  }
})
export default class RestaurantDialog extends Vue {
  @Prop({ default: false })
  value!: boolean;

  @Prop({
    default: function() {
      return new Restaurant();
    }
  })
  restaurant!: Restaurant;

  currentTab = 0;

  getBannerTitle() {
    if (this.createNewRestaurant) {
      return this.$t("restaurant.create.message");
    }
    return this.restaurant.restaurantName;
  }

  get tab() {
    return this.currentTab;
  }

  set tab(newVal) {
    if (this.currentTab === 0) {
      this.isAdmin && this.propertiesForm.resetFields();
    }
    this.currentTab = newVal;
  }

  get createNewRestaurant() {
    return this.restaurant.restaurantId == null;
  }

  get confirmationDialog() {
    return this.$refs.confirmationDialog as ConfirmationDialog;
  }

  get propertiesForm(): RestaurantPropertiesForm {
    return this.$refs.restaurantPropertiesForm as RestaurantPropertiesForm;
  }

  async deleteRestaurant() {
    if (
      await this.confirmationDialog.open(
        this.$tc("restaurant.delete.message"),
        this.$t("delete.confirmation") +
          "\n" +
          this.restaurant.restaurantName +
          "\n" +
          this.$t("delete.warning")
      )
    ) {
      try {
        await this.$store.dispatch("loading");
        await RemoteServices.deleteRestaurant(
          this.restaurant.restaurantId,
          "cancelation message"
        );
        this.dialog = false;
        this.removeRestaurant();
        await this.$store.dispatch(
          "success",
          this.$t("restaurant.delete.success")
        );
        if (
          (await this.$store.getters.getSelectedRestaurant.restaurantId) ===
          this.restaurant.restaurantId
        )
          await this.$store.dispatch("selectFirstRestaurant");
      } catch (error) {
        this.$store.dispatch("error", error.message);
      }
      this.$store.dispatch("clearLoading");
    }
  }

  get dialog() {
    return this.value;
  }

  set dialog(newValue) {
    this.$emit("input", newValue);
    this.isAdmin && this.propertiesForm.resetFields();
    this.currentTab = 0;
  }

  removeRestaurant() {
    this.$store.dispatch("deleteRestaurant", this.restaurant);
    // this.$emit("delete-restaurant", this.restaurant);
  }

  get isAdmin() {
    return this.$store.getters.isAdmin;
  }
}
